const standorte = [
    'MVZ Labor Limbach Aachen SE & Co. eGbR',
    'MDI Limbach Berlin GmbH',
    'Medizinisches Labor Ostsachsen MVZ eGbR',
    'MVZ Gemeinschaftslabor Cottbus GmbH',
    'MVZ Medizinische Labore Dessau Kassel GmbH ',
    'MVZ Labor Dortmund Leopoldstraße GmbH',
    'MVZ Labor Limbach Erfurt GmbH',
    'MVZ Labor Essen Nienkampstraße GmbH',
    'Laborarztpraxis Rhein-Main MVZ  GmbH & Co. eGbR',
    'MVZ Clotten Labor Dr. Haas, Dr. Raif & Kollegen GbR',
    'MVZ Limbach Füssen GmbH',
    'MVZ Limbach Hamburg GmbH',
    'MVZ Labor Dr. Limbach & Kollegen eGbR',
    'MVZ Labor PD Dr. Volkmann und Kollegen SE & Co. eGbR',
    'Kinderwunschzentrum Langenhagen-Wolfsburg MVZ GbR',
    'Limbach Nord GmbH',
    'MVZ Labor Dr. Reising-Ackermann und Kollegen GbR',
    'MVZ Labor Ludwigsburg SE & Co. eGbR ',
    'Labor Lübeck MVZ GmbH ',
    'Humicon B. V.',
    'Medizinisches Labor Prof. Dr. Schenk, Dr. Ansorge & Kollegen',
    'MVZ GANZIMMUN GmbH ',
    'Limbach Genetics eGbR',
    'Limbach Analytics GmbH',
    'Medizinisches Versorgungszentrum Dr. Stein + Kollegen SE & Co. eGbR',
    'MVZ Medizinische Labore Limbach München Rosenheim GmbH',
    'MVZ Labor Münster Hafenweg GmbH',
    'MVZ Labor Limbach Nürnberg GmbH',
    'MVZ Labor Passau GmbH',
    'MVZ Labor Ravensburg SE & Co. eGbR',
    'MVZ Labor Schweinfurt GmbH',
    'Labormedizinisches Versorgungszentrum Westmecklenburg GmbH',
    'MVZ Labor Prof. Blessing GmbH ',
    'MVZ Labor Limbach Vorpommern-Rügen GmbH',
    'Labor Prof. Dr. G. Enders MVZ GbR',
    'MVZ Humangenetik Ulm GbR',
    'MVZ Labor Dr. Fenner & Kollegen GmbH',
    'Labor Dr. Heidrich & Kollegen Medizinisches Versorgungszentrum',
    'MVZ Labor Krone GmbH',
    'Medics Labor AG',
];

standorte.sort((a, b) => a.localeCompare(b, 'de', {sensitivity: 'base'}))

export const STANDORTE = standorte;

